import debug from '../utils/console'
import { OpenFeature } from '@openfeature/web-sdk'
const logger = debug.extend('openfeature')

export default defineNuxtPlugin({
  name: 'openfeature',
  setup: async (nuxtApp) => {
    const {
      registerMultipleFeatureFlagProviders,
      registerFeatureFlagProvider,
    } = await import('../openfeature/client')
    const { configCatSdkKey } = useRuntimeConfig().public
    const {
      openfeature = {
        multiProvider: false,
        localProvider: false,
        queryProvider: false,
      },
    } = useAppConfig()
    const {
      multiProvider = false,
      localProvider = false,
      queryProvider = false,
    } = openfeature

    const options = {
      configCatKey: configCatSdkKey ?? undefined,
      localProvider,
      queryProvider,
    }
    const client = multiProvider
      ? await registerMultipleFeatureFlagProviders(options)
      : await registerFeatureFlagProvider(options)
    const targetingKey = useCookie('targetingKey')
    targetingKey.value = targetingKey.value || crypto.randomUUID()
    OpenFeature.setContext({
      targetingKey: targetingKey.value,
    })
    logger.log({ client })
    nuxtApp.provide('openfeature', client)
  },
})
